/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Record_VolumeInputs */

const en_us2_workout_live_record_volume = /** @type {(inputs: Workout_Live_Record_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best set volume`)
};

const pt_br2_workout_live_record_volume = /** @type {(inputs: Workout_Live_Record_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior volume numa série`)
};

const es_419_workout_live_record_volume = /** @type {(inputs: Workout_Live_Record_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayor volumen en una serie`)
};

const pt_pt2_workout_live_record_volume = /** @type {(inputs: Workout_Live_Record_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior volume numa série`)
};

const fr_fr2_workout_live_record_volume = /** @type {(inputs: Workout_Live_Record_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleur volume en une série`)
};

const de_de2_workout_live_record_volume = /** @type {(inputs: Workout_Live_Record_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestes Satzvolumen`)
};

const it_it2_workout_live_record_volume = /** @type {(inputs: Workout_Live_Record_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miglior volume in una serie`)
};

/**
* | output |
* | --- |
* | "Best set volume" |
*
* @param {Workout_Live_Record_VolumeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_record_volume = /** @type {((inputs?: Workout_Live_Record_VolumeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Record_VolumeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_record_volume(inputs)
	if (locale === "es-419") return es_419_workout_live_record_volume(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_record_volume(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_record_volume(inputs)
	if (locale === "de-DE") return de_de2_workout_live_record_volume(inputs)
	if (locale === "it-IT") return it_it2_workout_live_record_volume(inputs)
	return en_us2_workout_live_record_volume(inputs)
});
export { workout_live_record_volume as "workout-live.record_volume" }